import React from 'react';
import { styled } from '@mui/material/styles';
import { Card, CardMedia, IconButton, Typography, Link } from '@mui/material';
import { Favorite, FavoriteBorder } from '@mui/icons-material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const LightTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: theme.palette.common.white,
		color: 'rgba(0, 0, 0, 0.87)',
		boxShadow: theme.shadows[1],
		fontSize: 14,
	},
}));

const ProductCard = (props) => {
	return (
		<div className="lg:px-16 md:px-8 px-4 lg:py-8 md:py-4 py-2">
			<Card className="lg:w-64 lg:h-96 md:w-48 md:mx-8 md:h-64 w-72 h-88 relative mb-4">
				<div className="p-2">
					<CardMedia component="img" image={props.imageUrl} className="relative object-contain rounded" />
					<IconButton style={{ position: "absolute", zIndex: 1, top: 5, right: 5 }} onClick={props.handleAddLike}>
						{props.isLiked ?
							(<Favorite style={{ border: "1px solid #D1D1D1", borderRadius: "50%", backgroundColor: "white", padding: "2px", color: "red" }} />) : (<FavoriteBorder style={{ border: "1px solid grey", borderRadius: "50%", backgroundColor: "white", padding: "2px" }} />
							)}
					</IconButton>
					<Link href="https://nttdata-solutions.com/tr/" color="inherit" underline="none" target="_blank" rel="noopener">
						<div className="lg:space-y-4 md:space-y-2 space-y-1">
							<Typography style={{ fontWeight: "bold", textOverflow: "ellipsis" }} className="pt-2 pl-2">{props.name}</Typography>
							<p className="lg:text-base md:text-sm text-xs font-bold pl-2" style={{ border: "1px solid #E6EEF8", backgroundColor: "#E6EEF8" }}>{props.price + " TL"}</p>
							<LightTooltip
								title={props.description}
							>
								<p className="lg:text-base md:text-sm text-xs truncate" >{props.description}</p>
							</LightTooltip>
							<p className="lg:text-xs md:text-xs text-xs">{props.shippingMethod}</p>
						</div>
					</Link>
				</div>
			</Card>
		</div>
	);
};

export default ProductCard;